import React, { Component } from 'react';
import { FloatingLabel, Form, Button, Alert } from 'react-bootstrap';
import DBService from '../../service/DBService';
import { getCookie } from '../../service/Cookie';
import { Link } from 'react-router-dom';

class NewsKeywordSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: '',
      keywords: '',
      criteria: '',
      result: '',
      error: '',
      upsert: '',
    };
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    let body = {
      userId: this.getUserId()
    }
    DBService.newsKeywordsSettings(body)
      .then(result => {
        result = result.data;
        console.log('newsKeywordsSettings', result);
        if (result !== undefined && result.length > 0) {
          this.setState({ keywords: result[0].keywords, upsert: 'update' });
        } else {
          this.setState({ upsert: 'insert' });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getUserId() {
    let userId = '';
    let cookieValue = getCookie();
    if (cookieValue !== undefined && cookieValue.userId !== undefined) {
      userId = cookieValue.userId;
    }
    return userId;
  }

  updateUser = () => {
    if (this.validate() === 0) {
      let body = {
        'userId': this.getUserId(),
        'keywords': this.state.keywords,
        'criteria': ''
      }
      this.setState({ error: '', result: '' });
      if (this.state.upsert === 'update') { //Update
        DBService.newsKeywordsUpdateSettings(body)
          .then(result => {
            result = result.data;
            console.log('newsKeywordsUpdateSettings', result);
            if (result !== undefined && result.length !== undefined && result.length <= 0) {
              this.setState({ error: 'Error updating keywords, please try again.' });
            } else {
              this.setState({ result: 'Your keywords has been updated' });
            }
          })
          .catch((error) => {
            console.log(error);
            this.setState({ error: 'Error updating keywords, please try again' });
          });
      } else {  //Insert
        DBService.newsKeywordsCreateSettings(body)
        .then(result => {
          result = result.data;
          console.log('newsKeywordsCreateSettings', result);
          if (result !== undefined ) {
            this.setState({ result: 'Your keywords has been created' });
          } 
        })
        .catch((error) => {
          console.log(error);
          this.setState({ error: 'Error inserting keywords, please try again' });
        });
      }
    }

  }

  validate = () => {
    let errorCount = 0, error = '';

    // if (this.state.keywords !== '') {
    //   if (!/^[a-zA-Z][a-zA-Z0-9 ]+$/.test(this.state.keywords)) {
    //     errorCount++;
    //     error = 'Invalid First and Last name (Example Valid Name: John Smith)';
    //     this.setState({ 'error': error });
    //     return errorCount;
    //   }
    // }

    this.setState({ 'error': error });
    return errorCount;
  }

  render() {
    return (
      <>
        <h4>News/Blogs Keywords Search</h4>
        <FloatingLabel
          controlId="floatingInput"
          label="Keywords"
          key="name"
          className="mb-3"
        >
          <Form.Control as="textarea" placeholder="Keywords" style={{ height: '200px' }} value={this.state.keywords} onChange={e => this.setState({ keywords: e.target.value })} />
        </FloatingLabel>
        {(this.state.result !== '') ? (
          <Alert key='primary' variant='success'>
            {this.state.result}
          </Alert>
        ) : <></>}
        {(this.state.error !== '') ? (
          <Alert key='danger' variant='danger'>
            {this.state.error}
          </Alert>

        ) : <></>}
        <p></p>
        <Button variant="primary" onClick={this.updateUser}>Update</Button>{' '}

        <p></p>
        <div style={{textAlign: 'left'}}>
          Enter Keywords in a seperate line by hitting 'Enter' Key, example:<br></br>
          <div style={{color: 'blue', fontSize: '12px'}}>
            FDA Approval<br></br>
            Buyout<br></br>
            Upgrade<br></br>
            Beats Estimate<br></br>
            Acquisition<br></br>
            Collaboration Agreement<br></br>
            Merger<br></br>
            Buyback<br></br>
          </div>
          <br></br>
          <div>
            Periodically system scan through all the news for the keywords and email you.  You can also see all the notifications here:  
            {' '}<Link to="/notifications">Notifications</Link>
          </div>
        </div>
      </>
    )
  }
}

export default NewsKeywordSettings;